import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'antd';
import Chart from 'react-apexcharts';

import { formatters } from 'services';
import { FinancialInstrument, selectors } from 'state';
import { AreaChart } from 'components';
import { auctions_tenors } from '../../../../state/app/auctions/types';

type props = {
  height: number;
};

const YieldCurveGraph: React.FC<props> = ({ height }) => {
  // const data_old = useSelector(selectors.AFSDurationBreakdown());
  const current_yields = useSelector(selectors.todaysYields);
  const past_yields = useSelector(selectors.pastYields);

  // console.log(past_yields);

  // console.log('yields: ', yields);

  const curr_data = [
    {
      x: 0,
      y: current_yields.yields.wk4,
    },
    {
      x: 2,
      y: current_yields.yields.wk13,
    },
    {
      x: 3,
      y: current_yields.yields.wk26,
    },
    {
      x: 4,
      y: current_yields.yields.wk52,
    },
    {
      x: 5,
      y: current_yields.yields.yr2,
    },
    {
      x: 7,
      y: current_yields.yields.yr5,
    },
    {
      x: 9,
      y: current_yields.yields.yr10,
    },
    {
      x: 10,
      y: current_yields.yields.yr30,
    },
  ];

  const past_data = [
    {
      x: 0,
      y: past_yields.yields.wk4,
    },
    {
      x: 2,
      y: past_yields.yields.wk13,
    },
    {
      x: 3,
      y: past_yields.yields.wk26,
    },
    {
      x: 4,
      y: past_yields.yields.wk52,
    },
    {
      x: 5,
      y: past_yields.yields.yr2,
    },
    {
      x: 7,
      y: past_yields.yields.yr5,
    },
    {
      x: 9,
      y: past_yields.yields.yr10,
    },
    {
      x: 10,
      y: past_yields.yields.yr30,
    },
  ];

  // console.log('data: ', data);

  const series = [
    {
      name: 'Holding',
      data: curr_data,
    },
  ];

  const options: Record<string, unknown> = {
    chart: {
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
      },
    },
    title: {
      text: 'Yield Curve',
    },
    stroke: { curve: 'smooth', dashArray: [0, 6], width: [3, 3] },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      // gradient: {
      //   shadeIntensity: 1,
      //   inverseColors: false,
      //   opacityFrom: 0.5,
      //   opacityTo: 0,
      //   stops: [0, 90, 100],
      // },
    },
    yaxis: {
      labels: {
        formatter: formatters.commasExact2Digits,
        // ? yaxisFormatter
        // : (value: string | number | undefined) =>
        //     value?.toLocaleString?.() ?? '',
      },
    },
    xaxis: {
      labels: {
        formatter: (value: number) => auctions_tenors[value],
      },
      tooltip: false,
    },
  };

  return (
    <div
      style={{ minWidth: 242 }}
      // style={{ minWidth: 442 }}
    >
      {/*<Typography.Title*/}
      {/*  level={4}*/}
      {/*  style={{ whiteSpace: 'nowrap', marginBottom: 0 }}*/}
      {/*>*/}
      {/*  Yield Curve*/}
      {/*</Typography.Title>*/}
      <Chart
        height={height}
        series={[
          {
            name: 'Current yields',
            data: curr_data,
          },
          {
            name: 'Past yields',
            data: past_data,
          },
        ]}
        type={'line'}
        options={options}
      />
    </div>
  );
};

export default YieldCurveGraph;
